<template>
    <div class="content-services-texts">
        <!-- <div class="content-services-texts-title">Style3D<br />DPC</div> -->
        <CommonComponentsFlowingText :text="data.flowingText" class="content-services-texts-flowing" />
        <div class="content-services-texts-subtitle">{{ $t(data.desText) }}</div>
    </div>
</template>

<script lang="ts" setup>
    import { reactive } from 'vue';

    const data = reactive({
        flowingText: '3D modeling/ 3D Rendering/ 3D Animation/ Fabric/ General',
        desText: 'global_dpc_content_services_text_0',
    });
</script>

<style lang="less" scoped>
    .content-services-texts {
        font-style: normal;
        line-height: normal;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 40px 0;

        &-title {
            font-family: Montserrat;
            font-size: .convert(128px) [ @vw];
            font-weight: 500;
            text-transform: capitalize;
            text-align: center;
        }

        &-flowing {
            margin-top: .convert(40px) [ @vw];
            margin-bottom: .convert(100px) [ @vw];
        }
        &-subtitle {
            color: #fff;
            font-family: HarmonyOS Sans SC;
            font-size: .convert(48px) [ @vw];
            font-weight: 400;
        }

        @media (max-width: @screen-mobile-width) {
            margin: 30px 0 20px 0;

            &-flowing {
                margin-top: 0px;
                margin-bottom: 40px;
            }

            &-subtitle {
                font-size: 15px;
            }
        }
    }
</style>
